import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import './SwingScreener.css';
import { ChartScreenDataProps } from "../model/App";
import { FaArrowLeft } from "react-icons/fa";
import PremiumAccessPage from "./PremiumAccessPage.tsx";
import ScreenerTable from "./screener/ScreenerTable.tsx";


const SwingScreenerPage = ({ }: ChartScreenDataProps) => {

    const tableData = [
        {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        },
        {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        },
        {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        },
        {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        }, {
            stockName: "Fraser and Co Ltd.",
            symbol: "FCL",
            exchange: "NSE",
            ltp: "38.10",
            change: "25.55%",
            volume: "525152"
        },
        {
            stockName: "Op and Co Ltd.",
            symbol: "OPCL",
            exchange: "NSE",
            ltp: "18.10",
            change: "5.55%",
            volume: "98525152",
        },
    ];

    const ITEMS_PER_PAGE = 20;
    const [visibleData, setVisibleData] = useState<{
        stockName: string,
        symbol: string,
        exchange: string,
        ltp: string,
        change: string,
        volume: string,
    }[]>([]);
    const [page, setPage] = useState(1);

    const navigate = useNavigate();

    useEffect(() => {
        setVisibleData(tableData.slice(0, ITEMS_PER_PAGE));
    }, []);

    const loadMore = () => {
        const nextPage = page + 1;
        const newItems = tableData.slice(0, nextPage * ITEMS_PER_PAGE);
        setVisibleData(newItems);
        setPage(nextPage);
    };

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop + 100 >=
                document.documentElement.scrollHeight
            ) {
                if (visibleData.length < tableData.length) {
                    loadMore();
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [visibleData, page]);

    const handleViewChart = (chartUrl: string) => {
        if (!chartUrl) return;

        const newWindow = window.open(chartUrl, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;

    }

    return (
        <>
            <div className="main-content">
                {/* Header */}
                <div className="chart-header">
                    <button className="back-btn" onClick={() => navigate(-1)}>
                        <FaArrowLeft />
                    </button>
                    <h2 className="chart-title">Swing Stock screener</h2>
                </div>
                <ScreenerTable
                    apiEndpoint="/api/screener/swing"
                    initialPageSize={10}
                />
                {false ? (<><PremiumAccessPage /></>) : (<><div className="table-wrapper table-container">

                    <table className="scroll-table">
                        <thead>
                            <tr>
                                <th>Stock Name</th>
                                <th>Symbol</th>
                                <th>Exch</th>
                                <th>%Chg</th>
                                <th>LTP</th>
                                <th>Volume</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {visibleData.map((row, i) => (
                                <tr key={i}>
                                    <td>
                                        {row.stockName}
                                    </td>
                                    <td>{row.symbol}</td>
                                    <td>{row.exchange}</td>
                                    <td>{row.change}</td>
                                    <td>{row.ltp}</td>
                                    <td>{row.volume}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {visibleData.length < tableData.length && (
                        <p style={{ textAlign: "center", padding: "1rem" }}>Loading more...</p>
                    )}
                </div></>)
                }
            </div>
        </>
    );
}

export default SwingScreenerPage;